export const FETCH_ONE = 'connections/FETCH_ONE';
export const FETCH_ONE_SUCCESS = 'connections/FETCH_ONE_SUCCESS';
export const FETCH_COLLECTION = 'connections/FETCH_COLLECTION';
export const FETCH_COLLECTION_SUCCESS = 'connections/FETCH_COLLECTION_SUCCESS';
export const FETCH_HEADER_IMAGE = 'connections/FETCH_HEADER_IMAGE';
export const FETCH_HEADER_IMAGE_SUCCESS = 'connections/FETCH_HEADER_IMAGE_SUCCESS';
export const SAVE_READ_POST = 'connections/SAVE_READ_POST';
export const SAVE_READ_POST_SUCCESS = 'connections/SAVE_READ_POST_SUCCESS';
export const GET_READ_POSTS = 'connections/GET_READ_POSTS';
export const GET_READ_POSTS_SUCCESS = 'connections/GET_READ_POSTS_SUCCESS';
